import ScoreWheel from "components/ScoreWheel";
import styled, { ThemeProvider } from "styled-components";
import { colors } from "styles";
import getStatus from "utils/getStatus";
import { INTEREST_PER_STATUS } from "config";
import { LOAN_TYPES } from "config";
import calculateLoan from "utils/calculateLoan";

const Root = styled.div`
  background-color: ${colors.white};
  padding: 10px;
  border-bottom: 10px solid ${(props) => props.theme.colors[1]};
  overflow: hidden;
`;

const Content = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const Eyebrow = styled.div`
  font-size: 1em;

  @media (max-width: 384px) {
    font-size: 0.7em;
  }
`;

const Title = styled.div`
  font-size: 1.6em;
  font-weight: bold;
`;

const MoneyValue = styled.div`
  font-size: 1.3em;
  @media (max-width: 384px) {
    font-size: 0.9em;
  }
`;

const Subtitle = styled.div`
  font-size: 1em;
  @media (max-width: 390px) {
    font-size: 0.9em;
  }
`;

const FlexContainer = styled.div`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  gap: 1rem;
  border-top: 1px solid ${colors.gray};
  padding-top: 5px;
`;

const FlexItem = styled.li`
  & > div {
    display: inline-block;
  }
  flex-grow: auto;
`;

const Highlight = styled.strong`
  color: ${(props) => props.theme.colors[1]};
`;

const Score = styled.div`
  display: inline-flex;
  align-items: center;
`;

const Wrapper = styled.div`
  display: flex;
  gap: 10px;
`;

const StickyCreditSimulator = ({ score, loanType, person }) => {
  const status = getStatus(score);
  const interest = INTEREST_PER_STATUS[loanType][status.id];
  const { cost, months } = LOAN_TYPES[loanType];
  const monthlyPayment = calculateLoan(cost, interest, months);
  const interestCost = monthlyPayment * months - cost;

  return (
    <ThemeProvider theme={status}>
      <Root>
        <Wrapper>
          <Score>
            <div>
              <ScoreWheel
                $size="small"
                score={score}
                disabled
                $trackColor={colors.lightGray}
              />
            </div>
          </Score>

          <Content>
            <Subtitle>Simulador de crédito personalizado</Subtitle>
            {person && <Title>{person}</Title>}

            <FlexContainer>
              <FlexItem>
                <div>
                  <Eyebrow>Valor</Eyebrow>
                  <MoneyValue>
                    <Highlight>${cost.toLocaleString()}</Highlight>
                  </MoneyValue>
                </div>
              </FlexItem>
              <div
                style={{
                  borderRight: `solid 1px ${colors.gray}`,
                  marginRight: "auto",
                  marginLeft: "auto",
                }}
              />
              <FlexItem>
                <div>
                  <Eyebrow>
                    <Highlight>{interest}%</Highlight> interes
                  </Eyebrow>
                  <MoneyValue>
                    <Highlight>-${interestCost.toLocaleString()}</Highlight>
                  </MoneyValue>
                </div>
              </FlexItem>
              <div
                style={{
                  borderRight: `solid 1px ${colors.gray}`,

                  marginLeft: "auto",
                }}
              />
              <FlexItem style={{ marginLeft: "auto", marginRight: "auto" }}>
                <div>
                  <Eyebrow>Pago Mensual</Eyebrow>
                  <MoneyValue>
                    <Highlight>${monthlyPayment.toLocaleString()}</Highlight>
                  </MoneyValue>
                </div>
              </FlexItem>
            </FlexContainer>
          </Content>
        </Wrapper>
      </Root>
    </ThemeProvider>
  );
};

export default StickyCreditSimulator;
